<template>
  <div style="display: flex;position: relative;flex-direction: column;flex-grow: 1;max-height: calc(100vh - 100px)">
    <div class="katalog view" style="max-height: 100%" ref="scrollView" @scroll="onScroll">
      <title-bar :with-logo="false" :title="title"/>
      <div v-if="filterInfo" class="spacer-x text-center spacer-bottom">{{ _('Filter') }}: {{ filterInfo }}</div>
      <div v-if="items && items.length > 0 && watermark"
           ref="search_results"
           id="search_results"
           class="bs4-container-fluid bg-white">
        <div class="bs4-row">
          <template v-for="(item, idx) in items">
            <div
                class="bs4-col-12 bs4-col-lg-3 bs4-col-xl-2"
                :class="{'last-item': idx === items.length-2}"
            >
              <keep-alive>
                <kat-list-item
                    :key="'item-' + item.id"
                    :id="'item_' + item.id"
                    :item="item"
                    :favorite="isInInventory(item.id)"
                    :watermark="watermark"

                    @toggle-favorite="toggleFavorite(item)"
                    @process-img="forwardProcessImgEvent"
                    @enlarge-img="zoomedImage = $event"
                    @open="$router.push('/detail/'+$event, () => null, () => null)"
                >
                  <number-input
                      :key="'item-input-' + item.id"
                      :value="amountForConverter(item)"
                      @input="updateConverter(item, $event)"
                  />
                </kat-list-item>
              </keep-alive>

            </div>
          </template>
        </div>
      </div>
      <div class="text-center spacer-y" :class="{invisible: !waitForFetch}">
        <img src="@/img/hensel-loading.svg" class="spacer-bottom" alt="">
      </div>
      <div ref="end_of_list" style="padding-top: 50px"></div>
      <pinch-zoom-overlay :image="zoomedImage" @hide="zoomedImage = ''"></pinch-zoom-overlay>
    </div>
    <img src="@/img/toTop.svg"
         width="37"
         style="padding-bottom: env(safe-area-inset-bottom);transition: right .3s;position: fixed; bottom: 13vh; z-index: 999999"
         :style="scrollY >= 200?'right:0':'right:-100px'"
         @click="scrollToTop"
         alt=""
    >
    <div v-if="false"
         style="padding-bottom: env(safe-area-inset-bottom);transform: translate3d(0,0,0);position:fixed; bottom: 60px;left: 15px; right: 15px">
      <button class="bg-light-blue large-text search-button"
              @click="$router.push('/search', () => null, () => null)">
        {{ _('Suche') }}
      </button>
    </div>
  </div>
</template>
<script>
//Vuex
import { mapActions, mapMutations, mapState } from 'vuex'
//Mixins
import forwardEvents from '../mixins/forwardEvents.js'
import inventoryHelper from '../mixins/inventory-helper'
//Components
import TitleBar from '../components/TitleBar'
import Modal from '../components/Modal'
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion'
import CombinedImage from '../components/CombinedImage'
import PinchZoomOverlay from '../components/PinchZoomOverlay'
import KatListItem from '../components/KatListItem'
import NumberInput from '@/components/NumberInput'

export default {
  name: 'KATALOG',
  mixins: [forwardEvents, inventoryHelper],
  components: {
    NumberInput,
    KatListItem, PinchZoomOverlay, CombinedImage, BulmaAccordion, BulmaAccordionItem, Modal, TitleBar,
  },
  data () {
    return {
      zoomedImage: '',
    }
  },
  computed: {
    ...mapState({
      user: state => state.Api.Users.current,
      waitForFetch: state => state.waitForFetch,
      items: state => state.Api.Converters.all,
      scrollY: state => state.catalogueScrollY,
      filter: state => state.filter,
      attributes: state => state.Api.Converters.attributes,
    }),
    watermark () {
      if (!this.user) {
        return null
      }
      return this.user.watermark
    },
    filterInfo () {
      return Object.entries(this.filter)
          .map(([filterName, filterValue]) => {
            const attr = this.attributes[filterName + 's']
            if (attr) {
              const v = attr.find(el => el.id === filterValue)
              if (v) {
                return this.translateEntity(filterName, v)
              }
            } else if (filterName === 'query') {
              return filterValue
            } else {
              return null
            }
          })
          .filter(el => el)
          .join(', ')
    },
    title () {
      return this._('KATALOG')
    },
  },
  methods: {
    ...mapActions({
      fetchConverters: 'Api/Converters/all',
    }),
    ...mapMutations({
      setWaitForFetch: 'setWaitForFetch',
      setScrollY: 'setCatalogueScrollY',
    }),
    onScroll () {
      if (!this.$refs.scrollView) {
        return
      }

      //save scroll pos
      this.setScrollY(this.$refs.scrollView.scrollTop)

      //fetch more  converters when scrolls to the end of the list
      const lastItem = this.$refs.scrollView.getElementsByClassName('last-item')[0]
      if (
          lastItem
          && !this.waitForFetch
          && (this.$refs.end_of_list && this.$refs.end_of_list.offsetTop < document.body.clientHeight ||
              (lastItem.offsetTop - this.$refs.scrollView.clientHeight < this.$refs.scrollView.scrollTop))
      ) {
        this.setWaitForFetch(true)
        this.fetchConverters({
          filter: this.filter,
          limit: { offset: this.items.length, length: 12 },
          language: this._lang,
        })
            .then(() => {
              if (
                  this.$refs?.end_of_list
                  && this.$refs.end_of_list.offsetTop < document.body.clientHeight
              ) {
                this.setWaitForFetch(false)
                this.$nextTick(() => this.onScroll())
              }
            })
            .catch(this.apiErrorHandler)
            .finally(() => {
              this.$nextTick(() => this.setWaitForFetch(false))
            })
      }
    },
    scrollToTop () {
      if (!this.$refs?.scrollView) {
        return
      }

      this.setScrollY(0)
      this.$nextTick(() => this.$refs?.scrollView?.scroll?.(0, this.scrollY))
    },
  },
  async mounted () {
    if (!this.user) {
      this.$router.push({ name: 'Login' })
      return
    }

    if (this.items.length === 0) {
      this.setWaitForFetch(true)

      try {
        await this.fetchConverters({
          limit: { offset: this.items.length, length: 18 },
          language: this._lang,
        })
      } finally {
        this.setWaitForFetch(false)
      }
    }

    if ((this.$refs?.end_of_list?.offsetTop ?? Number.MAX_SAFE_INTEGER) < document.body.clientHeight) {
      this.onScroll()
    }

    this.$nextTick(() => this.$refs?.scrollView?.scroll?.(0, this.scrollY))
  },
}
</script>
